import React, { createContext } from 'react';


const CityCacheContext = createContext<React.MutableRefObject<{ [cityName: string]: string }> | null>(null);

export const CityCacheProvider = ({ children }: { children: React.ReactNode }) => {
  const cityCache = React.useRef<{ [cityName: string]: string }>({});

  return (
    <CityCacheContext.Provider value={cityCache}>
      {children}
    </CityCacheContext.Provider>
  );
};

export const useCityCache = () => {
  const ctx = React.useContext(CityCacheContext);
  if (!ctx) {
    throw new Error('useCityCache must be used within a CityCacheProvider');
  }
  return ctx;
};